import DataConst from 'consts/DataConst';

export default {
  name: DataConst.MODELS.SETTING,
  primaryKey: 'key',
  properties: {
    key: 'string',
    value: 'string'
  }
};
